var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoorOut = function SvgDoorOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.667 24H20.667C21.0353 24 21.3337 24.2983 21.3337 24.6666V26C21.3337 26.3683 21.0353 26.6666 20.667 26.6666H3.33366C2.96533 26.6666 2.66699 26.3683 2.66699 26V24.6666C2.66699 24.2983 2.96533 24 3.33366 24H5.33324V7.44998C5.33324 6.28248 6.23033 5.33331 7.33324 5.33331H16.667C17.7699 5.33331 18.667 6.28248 18.667 7.44998V24ZM13.3332 16C13.3332 16.7362 13.9303 17.3333 14.6666 17.3333C15.4032 17.3333 16.0003 16.7362 15.9999 16C15.9999 15.2637 15.4028 14.6666 14.6666 14.6666C13.9303 14.6666 13.3332 15.2637 13.3332 16ZM24.4808 14.684L24.4292 12.9318C24.4292 12.1033 25.4261 11.6884 26.0091 12.2742L29.0632 15.3429C29.4247 15.7061 29.4234 16.2936 29.0619 16.6567L26.0078 19.7254C25.4248 20.3112 24.4292 19.8977 24.4292 19.0692L24.4808 17.3143H21.3337V14.684H24.4808Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoorOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/door_out.684d0925.svg";
export { ForwardRef as ReactComponent };